<template>
	<div>
		<p class="view_head">单位信息</p>
		<div style="display: flex;flex-wrap: wrap;">
			<labelText spanTitle="单位名称" spanWidth="" componentWidth="520px" :pContent="newform.company_name">
			</labelText>
			<labelText spanTitle="统一社会信用代码" spanWidth="" componentWidth="520px" :pContent="newform.tax_number">
			</labelText>
			<labelText spanTitle="法定代表人" spanWidth="" componentWidth="520px" :pContent="newform.legalperson">
			</labelText>
			<labelText spanTitle="请填写总承包资质最高等级" spanWidth="" componentWidth="520px"
				:pContent="newform.qualification+','+newform.corporate_level">
			</labelText>
			<labelText spanTitle="联系人" spanWidth="" componentWidth="520px" :pContent="newform.contact_name">
			</labelText>
			<labelText spanTitle="联系电话" spanWidth="" componentWidth="520px" :pContent="newform.phone">
			</labelText>
			<labelText spanTitle="通讯地址" spanWidth="" componentWidth="520px"
				:pContent="[newform.province,newform.city,newform.address].join('')">
			</labelText>
		</div>
		<p class="view_head">小组信息</p>
		<div style="display: flex;flex-wrap: wrap;">
			<labelText spanTitle="小组名称" spanWidth="" componentWidth="520px" :pContent="newform.group_name">
			</labelText>
			<labelText spanTitle="小组简介" spanWidth="" componentWidth="520px" :pContent="newform.group_desp">
			</labelText>
			<labelText spanTitle="小组注册时间" spanWidth="" componentWidth="520px"
				:pContent="newform.register_time">
			</labelText>
			<labelText spanTitle="小组人数" spanWidth="" componentWidth="520px" :pContent="newform.group_person">
			</labelText>
			<labelText spanTitle="小组活动指导者姓名" spanWidth="" componentWidth="520px"
				:pContent="newform.instructor_name">
			</labelText>
			<labelText spanTitle="推进者培训结业证书编号" spanWidth="" componentWidth="520px"
				:pContent="newform.completion_certificate">
			</labelText>
			<labelText spanTitle="发证单位" spanWidth="" componentWidth="520px" :pContent="newform.issue_unit">
			</labelText>
			<div class="qc_clumView" style="width: 100%;">
				<div class="qc_newAdd" style="width: 100%;">
					<p>小组主要成员:</p>
				</div>
				<div class="qc_clumView_right" style="width: 100%;">
					<emelentTable ref="elementTbteam" @editMore="getTable" status="check" :outTable="outTable2"
						:outTabList="outTabList2"></emelentTable>
					<addQcTable ref="addQcTable" outerWidth="1050px" status="check">
					</addQcTable>
				</div>
			</div>
		</div>
		<p class="view_head">成果信息</p>
		<div style="display: flex;flex-flow: column;">
			<labelText spanTitle="成果名称" spanWidth="auto" componentWidth="520px"
				:pContent="newform.achievement_name">
			</labelText>
			<labelText spanTitle="成果类型" spanWidth="auto" componentWidth="520px"
				:pContent="newform.achievement_type == 1 ?'创新型' : '问题型' ">
			</labelText>
			<labelText spanTitle="主要活动过程和效果" spanWidth="auto" componentWidth="520px"
				:pContent="newform.activity">
			</labelText>
			<labelText spanTitle="本成果社会和经济效益，是否形成企业标准和工法等情况" spanWidth="auto" componentWidth="520px"
				:pContent="newform.economic_results">
			</labelText>
			<labelText spanTitle="历年主要成果奖情况" spanWidth="auto" componentWidth="520px"
				:pContent="newform.achievement_prize">
			</labelText>
			<labelText spanTitle="是否发布" spanWidth="auto" componentWidth="520px"
				:pContent="newform.is_publish ==1 ?'发布':'不发布'">
			</labelText>
			<labelText spanTitle="推荐单位" spanWidth="auto" componentWidth="520px"
				:pContent="newform.recommend_unit">
			</labelText>
		</div>
	</div>
</template>

<script>
	import labelText from '../../../components/table/labelText.vue'
	import emelentTable from '../../../components/table/elementTable.vue'
	import addQcTable from "../components/addQc_table.vue"
	export default {
		data() {
			return {
				localForm: [],
				input: '',
				textarea: '',
				newform: {},
				spanWidth: '150px',
				// 推荐单位
				// 推荐单位
				recommendValue: '',
				// 是否发布
				radio: '1',
				outTable2: [],
				outTabList2: [{
						prop: 'name',
						label: '姓名',
						width: ''
					}, {
						prop: 'idcard',
						label: '身份证号码',
						width: '160px'
					}, {
						prop: 'f_school',
						label: '毕业院校',
						width: ''
					}, {
						prop: 'f_education',
						label: '学历',
						width: ''
					},
					{
						prop: 'f_major',
						label: '专业',
						width: ''
					},
					{
						prop: 'work_time',
						label: '工作时间',
						width: ''
					}, {
						prop: 'position',
						label: '目前岗位',
						width: ''
					},
					{
						prop: 'post',
						label: '职务',
						width: ''
					}, {
						prop: 'title',
						label: '职称',
						width: ''
					},
				]
			}
		},
		components: {
			labelText,
			emelentTable,
			addQcTable
		},
		mounted() {
			setTimeout(() => {
				this.newform = {
					...this.datas
				}
				if (this.datas.main_member) {
					this.$refs.elementTbteam.setTableData(this.datas.main_member)
					this.datas.main_member.forEach((item, index) => {
						this.localForm[index] = item
					})
				}
			}, 1000)
		},
		props: {
			datas: {
				type: Object,
				default: () => {}
			}
		},
		watch: {
			datas(newValue) {
				// console.log('newValue', newValue)
				if (newValue) {
					setTimeout(() => {
						this.newform = {
							...newValue
						}
					})
					if (newValue.main_member) {
						this.$refs.elementTbteam.setTableData(newValue.main_member)
						newValue.main_member.forEach((item, index) => {
							this.localForm[index] = item
						})
					}
				}
			}
		},
		methods: {
			getTable(e) {
				const [index, type] = e
				this.$refs.addQcTable.openDialog(index, this.localForm[index])
			},
		}
	}
</script>

<style scoped>
	.view_head {
		font-size: 18px;
		font-weight: bold;
		margin-top: 20px;
	}

	.qc_list {
		display: flex;
		align-items: center;
		margin: 10px;
	}

	.qc_clumView {
		display: flex;
		flex-flow: column;
		margin: 10px;
		/* padding-left: 80px; */
		/* padding-left: 170px; */
	}

	.qc_newAdd {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 92%;
		margin-bottom: 10px;
	}

	.qc_clumView p {
		text-align: left;
		font-size: 14px;
		display: inline-block;
		margin-bottom: 10px;
	}

	.qc_clumView_right {
		width: 92%;
	}

	.qc_list__Right {
		padding-left: 20px;
	}

	.qc_list p {
		font-size: 14px;
		width: 150px;
		text-align: right;
		display: inline-block;
	}
</style>
